// extracted by mini-css-extract-plugin
module.exports = {"hideOnMobile":"_2DWSdbKC-_NNPeLFAaKmFL","hideOnDesktop":"_17LtjYCWX1aq4DMELwWRjo"};